import { isIterable } from "@thi.ng/checks/is-iterable";
import { cat } from "./cat.js";
import { comp } from "./comp.js";
import { iterator } from "./iterator.js";
import { map } from "./map.js";
export function mapcat(fn, src) {
    return isIterable(src) ? iterator(mapcat(fn), src) : comp(map(fn), cat());
}
